export const FormDataAuth = {
  email: null,
  otp: null,
};
export const FormDataISafeAuth = {
  iSafeNo: null,
  password: null,
};
export const FormValidasitonAuth = {
  email: [
    (v) => !!v?.trim() || "Email harus diisi.",
    (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "Format email tidak valid.",
  ],
};
export const FormValidationISafeAuth = {
  iSafeNo: [
    (v) => !!v?.trim() || "Nomor ISafe harus diisi.",
    (v) =>
      /^[A-Za-z0-9]+$/.test(v) ||
      "Nomor ISafe hanya boleh berisi huruf dan angka.",
  ],
  password: [
    (v) => !!v?.trim() || "Password harus diisi."
  ],
};
